export type dataTable = {
  id: string;
  code: string;
  name: string;
  color?: string;
  budgetItemsCount: number;
  state: string;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
};

export type TableProps = {
  data?: {
    activeCategories: dataTable[];
    inactiveCategories: dataTable[];
  };
};

export type SearchbarFilterTypes = (value: string) => void;

export const budgetCategoriesColumnNames = {
  code: {
    id: 'code',
    labelKey: 'tables:headers.code',
  },
  name: {
    id: 'name',
    labelKey: 'tables:headers.name',
  },
  color: {
    id: 'color',
    labelKey: 'tables:headers.color',
  },
  budgetItemsCount: {
    id: 'budgetItemsCount',
    labelKey: 'tables:headers.budgetItemsCount',
  },
};
